/**
 * @generated SignedSource<<be767f6a8976fb817217e913627de831>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationTeamButton_project$data = {
  readonly id: string;
  readonly teamsConnected: {
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "NavigationTeamButton_project";
};
export type NavigationTeamButton_project$key = {
  readonly " $data"?: NavigationTeamButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationTeamButton_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "concreteType": "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection",
      "kind": "LinkedField",
      "name": "teamsConnected",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ]
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "019729bc9738fb0fb680ee6b8a22b084";

export default node;
